<template>
  <div class="w-full">
    <CWPosts v-if="client === 'client1tenant'" :draft="draft" />
    <ExpoPosts v-else :draft="draft" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CWPosts from '../../careerwise/tenant/public/pages/Posts.vue'
import ExpoPosts from '../../expo/tenant/public/Posts.vue'

export default {
  components: {
    CWPosts,
    ExpoPosts,
  },

  props: {
    draft: { default: false },
  },

  computed: {
    ...mapGetters({
      client: 'shared/getClient',
    }),
  },
}
</script>
